import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=39e2ea40&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=ts&"
export * from "./HomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2ea40",
  null
  
)

export default component.exports